// SKH: fills in the date range for all three shipping speeds. No price is
// computed or shown here by design -- pricing stays on the checkout page
// only. Processing (order prep) is a Mon-Fri business-day count. Transit
// (carrier) excludes Sunday only, matching the store's actual shipping
// profile wording ("Delivery in X-Y days (Excluding Sundays)") -- not a
// Mon-Fri count.
(function () {
  function addBusinessDays(date, days) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return result;
  }

  function addDaysExcludingSunday(date, days) {
    var result = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0) added++;
    }
    return result;
  }

  function formatRange(start, end) {
    var opts = { month: 'short', day: 'numeric' };
    var startStr = start.toLocaleDateString('en-US', opts);
    if (start.getMonth() === end.getMonth()) {
      return startStr + '-' + end.getDate();
    }
    return startStr + ' - ' + end.toLocaleDateString('en-US', opts);
  }

  var TIERS = ['fastest', 'faster', 'free'];

  function render() {
    var widgets = document.querySelectorAll('.skh-delivery-estimate');
    widgets.forEach(function (widget) {
      var procMin = parseInt(widget.dataset.procMin, 10) || 2;
      var procMax = parseInt(widget.dataset.procMax, 10) || 2;
      var today = new Date();

      TIERS.forEach(function (tier) {
        var el = widget.querySelector('.skh-delivery-estimate__range--' + tier);
        if (!el) return;
        var min = parseInt(widget.dataset[tier + 'TransitMin'], 10);
        var max = parseInt(widget.dataset[tier + 'TransitMax'], 10);
        if (isNaN(min) || isNaN(max)) return;
        var earliest = addDaysExcludingSunday(addBusinessDays(today, procMin), min);
        var latest = addDaysExcludingSunday(addBusinessDays(today, procMax), max);
        el.textContent = formatRange(earliest, latest);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
